import React ,{  useEffect, useContext,useState }from 'react'
import * as API from '../utils/APICalls'
import { StorefrontContext, StorefrontProvider }  from "../context/StorefrontProvider";
import { AppContext } from "../context/AppProvider";
import { Box, Button, Container, Divider, IconButton, List, Modal,
  ListItem, ListItemIcon, Stack, Switch, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseButton from './CloseButton';
import CreateStorefontModal from './CreateStorefontModal';


const Artists = () => {
    const { appData, updateAppData, userData, artists,
        setCurrentArtist, currentArtist,
        setArtists, modalOpen, setModalOpen } = useContext(AppContext)
 
        const  handleArtistClick = (artist) =>{
            setCurrentArtist(artist)
            updateAppData({
                modalView:'artist-console'
            })
    
      }
        useEffect(()=>{
     const fetchArtists = async () =>{
       try{ 
         const data = await API.fetchArtists(userData?._id)
           if(data){
             await setArtists(data)
             await updateAppData({
               ...appData,
               artists
             })
             console.log('Artists:', data)
             
             
           }
         }catch(err){console.log(err)}
   }
   fetchArtists()
 },[])
  
        return (
    <Container sx={{fontFamily:'Gilroy, sans-serif',padding: '0.5rem'}}>
            {/* <div style={{position:'absolute', top:'0.5rem', right:'0.5rem'}}> */}
           {/* </div> */}
           <Box sx={{display: 'flex', justifyContent:'space-between',padding: '0.5rem'}}>
           <h2>Artists</h2>
         {/* <CreateStorefontModal /> */}
               
               <CloseButton func={updateAppData}  view='dash' val={{
                           modalOpen:!modalOpen,
                           modalView:''
                       }} />
           </Box>
           <ArrowBackIcon style={{fontSize:'2rem',//position:'absolute',
                       left:'2rem', cursor: 'pointer', opacity: '0.5',zIndex:9999,
                       top: '0.5rem', marginTop:'0.5rem'}}
                       onClick={()=>{
                        
                           // setSubView('review-cart') 
                           updateAppData({
                             ...appData,
                             modalView:'general-manager'
                           })
                         
                       }}
                       
                       />
           
         <List sx={{ display:'flex', flexDirection:'column',gap:'0.5rem',padding:'0.5rem'}} >
           { artists && artists?.map((a,i)=>{
             // try{
                 // let orders = fetchOrders(s?._id) 
                 // console.log('[Fetch Orders]:', orders)
                
               // }catch(err){console.log(err)}
             return (
               <ListItem key={i}
                 sx={{display:'flex', cursor: 'pointer', borderRadius:'10px',
                   boxShadow:'0px 0px 5px 1px rgba( 0, 0, 0 , 0.3 )',
                   '&:hover': {background:'rgba(144, 254, 195,0.5)'},
                   flexDirection:'column', width:'100%',border:'1px solid #757575'}} 
                 onClick={()=>{
                   handleArtistClick(a)
               }}> 
               <Box
                 sx={{display:'flex', gap:'0.5rem',justifyContent:'space-between', 
                   width:'100%', alignItems:'center', alignContent:'center'}} 
                 
             >
               <Box sx={{display:'flex',alignItems:'center', alignContent:'center',gap:'0.5rem'}}>
   
                           <Box component={'img'}
                             src={a?.pics[0]}
                             sx={{//position:'absolute',
                               borderRadius:'5px',
                               border:'1px solid #868686',
                               padding:'0.125rem',
                               boxShadow:'0px 0px 3px 1px rgba( 0, 0, 0,0.2),inset 0px 0px 3px 1px rgba( 0, 0, 0,0.5)',
                               width:'50px', height:'auto'}}
                           />
                 <Stack sx={{display:'flex', flexDirection:'row', gap:'0.5rem'}}>
                   <span> {a?.name}</span>
                   {/* <h3> {a?.actual_name}</h3> */}
                 </Stack>
                           {/* </span> */}
           
                   
               </Box>
                  {/* <Tooltip title='copy link'>
   
                       <IconButton onClick={(e)=>{
                           navigator.clipboard
                             .writeText(`https://qaura.pro/storefront/${s._id}`)
                             .then(() => {
                                 alert(`successfully copied`);
                             })
                             .catch(() => {
                                 alert("something went wrong");
                             });
                       }}>
                         <ContentCopyIcon />
                       </IconButton>
                       </Tooltip> */}
                       
                        
               </Box>
               </ListItem>
             )
           }) }
         </List>
       </Container>
  )
}

export default Artists